import { AcfuActingUserRole } from '../../types'
import { useAuth } from '../useAuth'
import { useIsFitterSchedulingMode } from '../useIsFitterSchedulingMode'

interface AcfuActingUser {
  actingUserId?: string
  actingUserRole: AcfuActingUserRole
}

// PX-3649: reuses the existing fitter-vs-consultant referrer signal (useIsFitterSchedulingMode)
// rather than a role-permission check, since that's the actual distinction the app already makes
// between a provider booking for themselves and a CS agent booking cold.
const useAcfuActingUser = (): AcfuActingUser => {
  const { user } = useAuth()
  const isFitterSchedulingMode = useIsFitterSchedulingMode()

  return {
    actingUserId: user?.account_id,
    actingUserRole: isFitterSchedulingMode ? 'PROVIDER' : 'CS_AGENT',
  }
}

export { useAcfuActingUser }
